__turbopack_context__.v({
  "content": "onboarding-page-module-scss-module__AmxR2q__content",
  "wrapper": "onboarding-page-module-scss-module__AmxR2q__wrapper",
});
